import React from "react";

// Styles
import Styles from "./zpinIntroBox.module.scss";
import { buttonStyles, StyledButton } from "../../../Shared/button/button";

function ZpinIntroBox({ handleZpinFlow }: any) {
  return (
    <div className={`${Styles.zpinBox}`}>
      <div className={`${Styles.zpinIntro}`}>
        <span className={`${Styles.newTag}`}>New</span>
        <h5 className="">Introducing ZPIN</h5>
      </div>
      <p>
        Create a 4-digit ZPIN and you’ll not need an OTP every time you change a
        setting in your dashboard!
      </p>
      <div className="button-group">
        <StyledButton
          id="z-pin-cta"
          className={`px-4 m-0 mt-2`}
          onClick={() => handleZpinFlow()}
          style={buttonStyles.borderDark.normal}
          hoverStyle={buttonStyles.borderDark.hover}
        >
          Create ZPIN
        </StyledButton>
      </div>
    </div>
  );
}

export default ZpinIntroBox;
